import { render, staticRenderFns } from "./EntryWriteDefaultLayout.vue?vue&type=template&id=2f7264d5&scoped=true"
import script from "./EntryWriteDefaultLayout.vue?vue&type=script&lang=js"
export * from "./EntryWriteDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7264d5",
  null
  
)

export default component.exports